import { useState } from 'react';

const faqs = [
  {
    title: 'Immediate Availability',
    answer:
      'We have immediate availability for all commercial asphalt paving projects across New Jersey. When you need an asphalt paver now, we are ready to mobilize quickly and get the job done right — no long waiting periods, no excuses.',
  },
  {
    title: 'Fast, Clean & Courteous Team',
    answer:
      'Our employees are fast, clean, and courteous on every job site. We respect your property and your time. From the moment we arrive to the moment we leave, you can expect a professional crew that keeps the work area tidy and communicates clearly.',
  },
  {
    title: 'Large & Small Projects Handled',
    answer:
      'We specialize in both large commercial projects and smaller paving needs across the entire state of New Jersey. Whether it\'s a massive parking lot resurfacing or a smaller commercial driveway, we bring the same level of expertise and dedication to every project.',
  },
];

export default function WhyChooseSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-16 md:py-20 bg-white relative" id="about">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left: text + accordion */}
          <div className="w-full lg:w-7/12">
            <div className="border-b-2 border-yellow-400 pb-4 mb-8 inline-block">
              <p
                className="text-3xl md:text-4xl font-extrabold uppercase leading-tight text-gray-900"
                style={{ fontFamily: "'Oswald', sans-serif" }}
              >
                Why Choose{' '}
                <span className="block text-yellow-500">NJ Commercial Asphalt?</span>
              </p>
            </div>
            <p className="text-gray-600 mb-8 text-base leading-relaxed max-w-xl">
              NJ Commercial Asphalt Paving is New Jersey&apos;s trusted name in commercial asphalt and pavement solutions. We service the entire state with a fast, professional team that treats every project — large or small — with the same commitment to quality.
            </p>

            <div className="space-y-4">
              {faqs.map((faq, i) => (
                <div
                  key={faq.title}
                  className="border border-gray-200 rounded-md overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer text-left"
                    onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                  >
                    <h4
                      className="text-base font-bold text-gray-900 uppercase"
                      style={{ fontFamily: "'Oswald', sans-serif" }}
                    >
                      {faq.title}
                    </h4>
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i
                        className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-yellow-500 text-xl`}
                      ></i>
                    </div>
                  </button>
                  {openIndex === i && (
                    <div className="px-5 py-4 bg-white text-gray-600 text-sm leading-relaxed border-t border-gray-200">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right: image */}
          <div className="w-full lg:w-5/12">
            <div className="rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/3857de841b532bfc4835826ec1e25200.jpg"
                alt="Asphalt paving truck and roller compactor on job site"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
